import type { CourseModule } from "@/core/types";
import { lektionTabelleAnlegen } from "./lektion-01-anlegen";
import { lektionTabellenkopf } from "./lektion-02-kopfzeile";
import { lektionTabellenformatvorlagen } from "./lektion-03-formatvorlagen";
import { lektionTabellenUmgang } from "./lektion-04-umgang";
import { lektionTabellenRechnen } from "./lektion-05-rechnen";
import { lektionTabellenAbschluss } from "./lektion-06-abschluss";

export const modulTabellen: CourseModule = {
  id: "tabellen",
  title: "Tabellen",
  summary:
    "Daten in Zeilen und Spalten ordnen – mit echter Überschriftenzeile und " +
    "Tabellenformatvorlagen statt selbst gezogener Rahmen.",
  level: "Grundlagen",
  lessons: [
    lektionTabelleAnlegen,
    lektionTabellenkopf,
    lektionTabellenformatvorlagen,
    lektionTabellenUmgang,
    lektionTabellenRechnen,
    lektionTabellenAbschluss,
  ],
};
